import React from 'react';
import PropTypes from 'prop-types';
import { useSearchResultsActions } from '@sitecore-search/react';

const PopularSearchCard = ({
    itemId,
    itemIndex,
    sourceId,
    title,
    description,
    link,
    cardImage
}) => {
    const { onItemClick } = useSearchResultsActions();
    return (
        <a href={link?.href || "#"} className="c-popular-search-card" onClick={() => {
            onItemClick({
                id: itemId,
                index: itemIndex,
                sourceId: sourceId
            });
        }}>
            <div className="card-image-box">
                <div className="card-image">
                    {cardImage ? (
                        <img
                            src={cardImage}
                            alt={title || "Popular Search"}
                        />
                    ) : (
                        <div className="card-image-placeholder" />
                    )}
                </div>
            </div>
            <div className="card-content">
                <div className="card-header">
                    <h3 className="card-title">{title}</h3>
                    {description && (
                        <div className="card-description">
                            {description}
                        </div>
                    )}
                </div>

                {link && (
                    <div className="card-link">{link?.label || "Read more"}</div>
                )}
            </div>
        </a>
    );
};

PopularSearchCard.propTypes = {
    itemId: PropTypes.string,
    itemIndex: PropTypes.number,
    sourceId: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    link: PropTypes.shape({
        label: PropTypes.string,
        href: PropTypes.string
    }),
    cardImage: PropTypes.string
};

export default PopularSearchCard;
